export default __webpack_public_path__ + "static/media/003-Virtual glasses.e5312a9a.svg";